var _G, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path, Defs, LinearGradient, Stop } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: filter */
var SvgHomePlate2 = function SvgHomePlate2(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 145.8 139.32"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    filter: "url(#home-plate-2_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#770700",
    d: "M116.797 131.22H29.003c-11.544 0-20.903-9.396-20.903-20.987v-62.96c0-11.59 9.359-20.987 20.903-20.987h4.337C42.922 15.15 57.09 8.1 72.9 8.1s29.978 7.049 39.561 18.187h4.336c11.544 0 20.903 9.396 20.903 20.986v62.96c0 11.591-9.359 20.987-20.903 20.987"
  }), /*#__PURE__*/React.createElement(Path, {
    fill: "url(#home-plate-2_svg__b)",
    d: "M116.797 131.22H29.003c-11.544 0-20.903-9.396-20.903-20.987v-62.96c0-11.59 9.359-20.987 20.903-20.987h4.337C42.922 15.15 57.09 8.1 72.9 8.1s29.978 7.049 39.561 18.187h4.336c11.544 0 20.903 9.396 20.903 20.986v62.96c0 11.591-9.359 20.987-20.903 20.987"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "home-plate-2_svg__b",
    x1: 72.9,
    x2: 73.279,
    y1: 8.1,
    y2: 107.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    offset: 0.196,
    stopColor: "#B00E19"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.801,
    stopColor: "#7B0007"
  })))));
};
export default SvgHomePlate2;